export default "__VITE_ASSET__Dc2R64wG__"